/**
 * @param obj -> Object<Any>
 * @param arrOfFieldsName -> Array<String>
 * @returns this -> Object<>
 * will return errors object that has the fields with error messages
 */
export const MAX_CHAR = 255;
export const MAX_PHONE_NUMBER = 16;

class Errors {
  constructor() {
    this.validateRequiredFields = this.validateRequiredFields.bind(this);
    this.validateJPEGFields = this.validateJPEGFields.bind(this);
  }

  validateRequiredFields(obj, arrOfFieldsName) {
    const errorMessage = 'Please enter a value';
    arrOfFieldsName.forEach(keyname => {
      if (!obj[keyname] || obj[keyname].trim() === '') {
        this[keyname] = errorMessage;
      }
    });
  }

  validateJPEGFields(obj, arrOfFieldsName) {
    arrOfFieldsName.forEach(keyname => {
      if (!obj[keyname] || obj[keyname].code === '') {
        this[keyname] = 'Please upload required document';
      } else if (obj[keyname] && obj[keyname].code === 'forbiden type') {
        this[keyname] = 'Only jpg, jpeg, png, and pdf are accepted';
      } else if (obj[keyname] && obj[keyname].code === 'file Too Big') {
        this[keyname] = 'The maximum file size is only 2MB';
      } else if (obj[keyname] && obj[keyname].code === 'tampered file') {
        this[keyname] =
          'The image has been tampered, please upload another one';
      }
    });
  }
}

export default Errors;
